module.exports = __webpack_public_path__ + "static/media/27.07_Post_01.0ec3bfc3.jpg";